module.exports = __webpack_public_path__ + "media/images/vedett_allatok/vedett8-f2f7854a9fc6eb628de1046fe502e8e9.jpg";